<!-- Il selettore della lingua del sito (menu Accedi, menu mobile, footer). I nomi
     delle lingue non si traducono (translate="no"): chi non legge l'italiano
     deve trovare «EN». Aggiungere una lingua: src/i18n/languages.js. -->
<template>
  <div class="lang-switch" :class="[`lang-switch--${variant}`]" translate="no" role="group" :aria-label="label">
    <Globe class="lang-switch__icon" :size="spelledOut ? 18 : 16" aria-hidden="true" />
    <template v-for="(lang, i) in languages" :key="lang.code">
      <span v-if="i > 0" class="lang-switch__sep" aria-hidden="true">·</span>
      <button
        type="button"
        class="lang-switch__btn"
        :class="{ 'is-active': lang.code === current }"
        :aria-pressed="lang.code === current ? 'true' : 'false'"
        :title="lang.nativeName"
        :lang="lang.code"
        :disabled="loading"
        @click="choose(lang.code)"
      >
        {{ spelledOut ? lang.nativeName : lang.short }}
      </button>
    </template>
  </div>
</template>

<script>
import { Globe } from 'lucide-vue-next';
import { LANGUAGES, i18nState, setLocale } from '@/i18n';

export default {
  name: 'LanguageSwitcher',
  components: { Globe },
  props: {
    // header: compatto (IT · EN); menu (tendina Accedi) e drawer: nomi interi;
    // footer: chiaro su scuro.
    variant: { type: String, default: 'header' },
  },
  data() {
    return { languages: LANGUAGES, state: i18nState };
  },
  computed: {
    current() {
      return this.state.locale;
    },
    spelledOut() {
      return this.variant === 'drawer' || this.variant === 'menu';
    },
    loading() {
      return this.state.loading;
    },
    // Etichetta per i lettori di schermo, nelle due lingue: vale per chiunque.
    label() {
      return 'Lingua / Language';
    },
  },
  methods: {
    choose(code) {
      setLocale(code);
    },
  },
};
</script>

<style scoped>
.lang-switch {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  line-height: 1;
  color: #6b7280;
}
.lang-switch__icon {
  margin-right: 2px;
  flex-shrink: 0;
}
.lang-switch__sep {
  color: #c4c4c4;
}
.lang-switch__btn {
  background: none;
  border: 0;
  padding: 4px 3px;
  font: inherit;
  color: inherit;
  cursor: pointer;
  border-radius: 4px;
}
.lang-switch__btn:hover {
  color: #111827;
}
.lang-switch__btn.is-active {
  color: #111827;
  font-weight: 600;
}
.lang-switch__btn:focus-visible {
  outline: 2px solid #499b79;
  outline-offset: 1px;
}
.lang-switch__btn:disabled {
  cursor: progress;
}
.lang-switch--drawer {
  font-size: 15px;
  gap: 8px;
}
.lang-switch--menu {
  font-size: 15px;
  gap: 8px;
}
.lang-switch--footer {
  color: inherit;
  opacity: 0.85;
}
.lang-switch--footer .lang-switch__btn:hover,
.lang-switch--footer .lang-switch__btn.is-active {
  color: inherit;
  opacity: 1;
}
</style>
